import { Input, Tooltip } from 'antd';
import API from 'API';
import { NotFound } from 'AppRoute';
import { useAuth } from 'AuthContext';
import AudioRecorder from 'components/general/AudioRecorder';
import MessageBox from 'components/general/MessageBox';
import FullMask from 'components/layout/FullMask';
import React, { useCallback, useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom';
import toastr from 'toastr';
import { CloseOutlined, DashboardFilled, MessageFilled } from '@ant-design/icons';
import { correct_media, createFormData } from 'general_function';
import ReactMarkdown from 'react-markdown';

const KEY_LIST = ["Từ vựng", "Phát âm", "Lưu loát", "Ngữ điệu", "Ngữ pháp", "Cải thiện"]

function Feedback({ feedback }) {
    return <div className='no-margin-p-child' style={{ maxHeight: 400, overflowY: "auto"}}>
        {KEY_LIST.map(key=><>
            <b>{key}:</b>
            <ReactMarkdown style={{ whiteSpace: "pre-wrap" }}>{feedback[key]}</ReactMarkdown>
        </>)}
    </div>
}

function ShowAudio({ item }) {
    return <div style={{ position: "relative" }}>
        <audio 
            autoPlay={!item.me}
            controls style={{ marginTop: 5, maxWidth: "100%", height: 40 }}>
                <source src={correct_media(item.file)} type="audio/mpeg" />
                Trình duyệt không hỗ trợ audio.
        </audio>
        <div>
            <Tooltip rootClassName="audio-message-tooltip" title={item.message} color='rgb(27, 90, 112)' zIndex={10100}>
                <MessageFilled style={{
                    cursor: "pointer",
                    marginRight: 3
                }}/>
            </Tooltip>
            {item.feedback && <Tooltip rootClassName="audio-message-tooltip" zIndex={10100} title={<Feedback feedback={item.feedback} />} 
                color='rgb(27, 90, 112)'>
                <DashboardFilled style={{
                    cursor: "pointer"
                }}/>
            </Tooltip>}
        </div>
    </div>
}

export default function SpeechChatBot({ course_id, setClose }) {
    const [loading, setLoading] = useState(true);
    const [searchParams] = useSearchParams();
    const [numberOfChats, setNumberOfChats] = useState(null);
    const [courseName, setCourseName] = useState("");
    const [conversationId, setConversationId] = useState(null);
    const [topic, setTopic] = useState("");
    const token = searchParams.get("token");
    const { user } = useAuth();
    useEffect(() => {
        if (!(token || (course_id && user))) return;
        API.post("get-chatbot-audio-answer/", {
            token: token,
            course_id: course_id,
        })
            .then(res => {
                setLoading(false);
                setNumberOfChats(res.data.chats);
                setCourseName(res.data.lesson);
            })
            .catch(error => {
                console.log(error);
                if (error.response?.status === 400) {
                    toastr.error("Token không hợp lệ!");
                }
            })
    }, [token, course_id, user])

    const sendMessage = useCallback(async (message, setMessage, chats, setChats) => {
        if (!topic.trim()) {
            toastr.error("Nhập chủ đề trước khi bắt đầu hội thoại!");
            return null;
        }
        try {
            const response = await API.post("get-chatbot-audio-answer/", createFormData({
                token: token,
                course_id: course_id,
                topic: topic,
                file: message,
                conversation_id: conversationId
            }, "audio.wav"), {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })
            setMessage("");
            setChats(chats => [
                ...chats,
                ...response.data.result
            ]);
            if (!conversationId) {
                setConversationId(response.data.conversation_id);
            }
            return null;
        } catch (error) {
            return null;
        }
    }, [topic, conversationId, token, course_id])

    if (!(token || (course_id && user))) {
        return <NotFound />
    }
    return loading ? <FullMask /> : <>
        {token ? <h4>{courseName}</h4> : null}
        <div style={{
            border: "1px solid rgb(211, 211, 211)",
            borderRadius: 5,
        }}>
            <div style={{
                top: 0, left: 0, width: "100%",
                borderBottom: "1px solid rgb(218, 218, 218)",
                backgroundColor: "rgb(255, 255, 255)",
                color: "white !important",
                borderRadius: "5px 5px 0px 0px"
            }}>
                <div
                    style={{
                        display: "inline-block",
                        width: setClose ? "calc(100% - 19px)" : "100%",
                        paddingLeft: 5, paddingRight: 5,
                    }}
                >
                    <Input
                        value={topic} onChange={e => setTopic(e.target.value)}
                        style={{ border: 0, outline: "0px !important" }}
                        placeholder='Topic: Bạn hãy nhập chủ đề bạn muốn hội thoại vào đây'
                    />
                </div>
                {setClose && <div style={{
                    display: "inline-block",
                    borderLeft: "1px solid rgb(172, 172, 172)",
                    width: 18, height: 22, textAlign: "center",
                    cursor: "pointer"
                }} onClick={setClose}>
                    <CloseOutlined />
                </div>}
            </div>
            <MessageBox defaultChat={[]} sendMessage={sendMessage}
                renderMessage={item => <ShowAudio item={item} />}
                renderInput={(message, setMessage) => <AudioRecorder message={message} setMessage={setMessage} small={setClose !== undefined} />}
            />
        </div>
    </>
}
